import { defineComponent as A, inject as W, computed as h, openBlock as r, createElementBlock as u, Fragment as I, createElementVNode as d, normalizeClass as f, withDirectives as H, vModelCheckbox as G, unref as C, createBlock as E, createCommentVNode as w, useSlots as U, ref as b, watch as K, onMounted as J, toDisplayString as V, withModifiers as $, renderList as Q, createVNode as B, normalizeStyle as X, renderSlot as R, vShow as Y, withKeys as Z, createSlots as ee, withCtx as le } from "vue";
import { CheckIcon as te, ChevronUpIcon as ae, ChevronDownIcon as oe } from "@frontiers/brink-icons";
import { onClickOutside as se, useFocusWithin as ie } from "@vueuse/core";
import { ValidationMessage as ne } from "../validationMessage.es.js";
import { Spinner as re } from "../spinner.es.js";
import '../assets/index41.css';const ce = ["id", "disabled", "data-event"], ue = ["for", "innerHTML"], de = /* @__PURE__ */ A({
  __name: "Checkbox",
  props: {
    id: { default: "" },
    label: { default: "" },
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    errorMessage: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(x, { emit: S }) {
    const o = x, s = W("sanitize"), n = h(() => o.errorMessage ? o.errorMessage.length > 0 : !1), k = h(() => {
      const t = [];
      return p.value && !o.indeterminate && !n.value && t.push("Checkbox--checked"), o.indeterminate && t.push("Checkbox--indeterminate"), n.value && t.push("Checkbox--error"), o.disabled && t.push("Checkbox--disabled"), t;
    }), p = h({
      get: () => o.modelValue,
      set: (t) => {
        S("update:modelValue", t);
      }
    }), i = (t) => {
      t && t.target && S("update:modelValue", t.target.checked);
    };
    return (t, v) => (r(), u(I, null, [
      d("div", {
        class: f(["Checkbox", k.value])
      }, [
        H(d("input", {
          id: t.id,
          type: "checkbox",
          class: "Checkbox__input",
          "onUpdate:modelValue": v[0] || (v[0] = (m) => p.value = m),
          onChange: i,
          disabled: t.disabled,
          "data-event": t.$ga.getDataEventValue("checkbox", p.value.toString(), t.label)
        }, null, 40, ce), [
          [G, p.value]
        ]),
        d("label", {
          for: t.id,
          class: "Checkbox__label",
          innerHTML: C(s)(t.label)
        }, null, 8, ue)
      ], 2),
      n.value ? (r(), E(ne, {
        key: 0,
        message: t.errorMessage
      }, null, 8, ["message"])) : w("", !0)
    ], 64));
  }
});
const pe = {
  key: 0,
  class: "Listbox__header"
}, ve = { class: "Listbox__header-selected-values" }, _e = ["onClick"], he = {
  key: 0,
  class: "Listbox__caption"
}, fe = ["data-index", "aria-disabled", "aria-selected", "data-event", "onClick"], be = {
  key: 0,
  class: "Listbox__multiple-option"
}, me = {
  key: 1,
  class: "Listbox__single-option"
}, ge = { key: 0 }, ye = { class: "Listbox__option-text" }, Ce = {
  key: 1,
  class: "Listbox__empty"
}, Se = /* @__PURE__ */ A({
  __name: "Listbox",
  props: {
    options: {},
    modelValue: {},
    variant: {},
    multiSelectable: { type: Boolean },
    captionMessage: {},
    show: { type: Boolean }
  },
  emits: ["click-selected", "clear-all"],
  setup(x, { emit: S }) {
    const o = x, s = U(), n = b(null), k = b(null), p = b(-1), i = b(-1);
    function t(l, _) {
      o.multiSelectable || (p.value = _), S("click-selected", l);
    }
    function v() {
      i.value = -1, S("clear-all");
    }
    function m(l) {
      if (typeof o.modelValue == "string")
        return o.modelValue === l;
      if (Array.isArray(o.modelValue))
        return o.modelValue.includes(l);
    }
    const D = () => {
      if (n.value) {
        const l = n.value.querySelector(
          `li[data-index="${i.value}"]`
        );
        if (i.value === 0)
          n.value.scrollTop = 0;
        else if (l) {
          const _ = l.clientHeight, a = n.value.clientHeight - _;
          a <= l.offsetTop ? n.value.scrollTop = l.offsetTop - a : n.value.scrollTop >= l.offsetTop && (n.value.scrollTop = n.value.scrollTop - l.clientHeight);
        }
      }
    }, L = (l) => {
      const a = o.options.length;
      if (l.code === "ArrowUp" && i.value > 0) {
        if (i.value === 0)
          return;
        i.value--, l.preventDefault();
      } else
        l.code === "ArrowDown" && i.value < a ? (i.value === a - 1 && (i.value = -1), i.value++, l.preventDefault()) : (l.code === "Enter" || l.code === "Space") && (l.preventDefault(), t(
          o.options[i.value].value,
          i.value
        ));
      D();
    }, z = () => {
      window !== void 0 && (o.show === !0 ? window.addEventListener("keydown", L) : window.removeEventListener("keydown", L));
    };
    return K(
      () => o.show,
      () => {
        z(), o.show || (i.value = -1);
      }
    ), J(() => {
      z();
    }), (l, _) => {
      var a;
      return H((r(), u("div", {
        ref_key: "listboxRef",
        ref: n,
        class: "Listbox"
      }, [
        l.multiSelectable ? (r(), u("div", pe, [
          d("span", ve, V(`${((a = l.modelValue) == null ? void 0 : a.length) ?? 0} selected`), 1),
          d("button", {
            "aria-label": "Clear all previously selected options",
            class: "Listbox__header-clear-button",
            onClick: $(v, ["stop", "prevent"])
          }, " Clear all ", 8, _e)
        ])) : w("", !0),
        d("ul", {
          ref_key: "listboxOptionsRef",
          ref: k,
          role: "listbox",
          class: "Listbox__options"
        }, [
          o.captionMessage ? (r(), u("div", he, V(o.captionMessage), 1)) : w("", !0),
          (r(!0), u(I, null, Q(l.options, (c, g) => (r(), u("li", {
            key: c.value,
            "data-index": g,
            class: f(["Listbox__option", {
              "Listbox__option--selected": m(c.value),
              "Listbox__option--disabled": !!c.disabled,
              "Listbox__option--active": g === p.value,
              "Listbox__option--arrowActive": g === i.value
            }]),
            "aria-disabled": !!c.disabled,
            "aria-selected": m(c.value),
            role: "option",
            "data-event": l.$ga.getDataEventValue("listbox", "option"),
            onMousedown: _[0] || (_[0] = $(() => {
            }, ["stop", "prevent"])),
            onClick: $((M) => !c.disabled && t(c.value, g), ["stop", "prevent"])
          }, [
            o.variant === "checkbox" ? (r(), u("div", be, [
              B(C(de), {
                label: c.label,
                "model-value": m(c.value),
                id: `listbox-option-${g}`,
                "onUpdate:modelValue": (M) => t(c.label, g)
              }, null, 8, ["label", "model-value", "id", "onUpdate:modelValue"])
            ])) : (r(), u("div", me, [
              o.variant === "ticks" ? (r(), u("div", ge, [
                B(C(te), {
                  style: X({
                    visibility: m(c.value) ? "visible" : "hidden"
                  }),
                  size: "md"
                }, null, 8, ["style"])
              ])) : w("", !0),
              d("span", ye, V(c.label), 1)
            ]))
          ], 42, fe))), 128)),
          C(s)["empty-content"] ? (r(), u("div", Ce, [
            R(l.$slots, "empty-content")
          ])) : w("", !0)
        ], 512)
      ], 512)), [
        [Y, l.show]
      ]);
    };
  }
});
const ke = ["aria-expanded", "data-event", "onKeydown"], we = { class: "ChipSelect__empty-message" }, Me = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "ChipSelect",
  props: {
    label: {},
    options: {},
    modelValue: {},
    variant: { default: "single" },
    loading: { type: Boolean },
    emptyMessage: { default: "No options available" },
    size: { default: "lg" },
    color: { default: "black" },
    disabled: { type: Boolean },
    readonly: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(x, { expose: S, emit: o }) {
    const s = x, n = U(), k = b(null), p = b(null), i = b(null), t = b(s.modelValue), v = b(!1);
    S({
      select: k,
      trigger: p
    });
    const m = {
      xl: "lg",
      lg: "md"
    }, D = {
      xl: "md",
      lg: "sm"
    }, L = h(() => m[s.size]), z = h(() => !!n.icon && !n.avatar), l = h(() => !!n.avatar && n.avatar().length > 0), _ = h(() => D[s.size]), a = h({
      get: () => t.value,
      set: (e) => {
        t.value = e, o("update:modelValue", e), o("change", e);
      }
    }), c = h(() => {
      var e;
      return s.variant === "single" && typeof a.value == "string" && a.value.length > 0 ? ((e = s.options.find((y) => y.value === t.value)) == null ? void 0 : e.label) ?? "" : s.variant === "multiple" && a.value.length > 0 ? `${a.value.length} selected` : "";
    }), g = h(() => s.loading ? "Loading..." : ""), M = h(() => s.variant === "multiple" ? a.value.length > 0 : a.value !== "");
    se(i, T, { ignore: [p] });
    const { focused: N } = ie(k);
    K(N, (e) => {
      e || T();
    });
    function O() {
      !s.disabled && !s.readonly && (v.value = !v.value);
    }
    function T() {
      v.value = !1;
    }
    function F(e) {
      return s.variant === "multiple" ? a.value.includes(e) : a.value === e;
    }
    function j(e) {
      s.variant === "single" && (a.value = e, T()), s.variant === "multiple" && (F(e) ? a.value = a.value.filter(
        (y) => y !== e
      ) : a.value = [...a.value, e]);
    }
    function q() {
      a.value = [];
    }
    return (e, y) => (r(), u("div", {
      ref_key: "selectRef",
      ref: k,
      class: "ChipSelect",
      onMousedown: y[1] || (y[1] = $(() => {
      }, ["prevent"]))
    }, [
      d("button", {
        ref_key: "triggerRef",
        ref: p,
        role: "combobox",
        class: f(["ChipSelect__trigger", [
          `ChipSelect__trigger--${e.size}`,
          `ChipSelect__trigger--${e.color}`,
          {
            "ChipSelect__trigger--selected": M.value,
            "ChipSelect__trigger--disabled": e.disabled,
            "ChipSelect__trigger--readonly": e.readonly,
            "ChipSelect__trigger--has-icon": z.value,
            "ChipSelect__trigger--has-avatar": l.value
          }
        ]]),
        "aria-expanded": v.value,
        "aria-haspopup": "listbox",
        "data-event": e.$ga.getDataEventValue("chipSelect", "button"),
        onClick: O,
        onKeydown: Z($(T, ["prevent"]), ["escape"])
      }, [
        l.value ? (r(), u("div", {
          key: 0,
          class: f(["ChipSelect__avatar", [
            `ChipSelect__avatar--${e.size}`,
            `ChipSelect__avatar--${e.color}`,
            { "ChipSelect__avatar--disabled": e.disabled }
          ]])
        }, [
          R(e.$slots, "avatar")
        ], 2)) : w("", !0),
        z.value ? (r(), u("div", {
          key: 1,
          class: f(["ChipSelect__icon", `ChipSelect__icon--${e.size}`])
        }, [
          R(e.$slots, "icon", {
            size: L.value,
            fill: "currentColor"
          })
        ], 2)) : w("", !0),
        d("div", {
          class: f(["ChipSelect__texts", `ChipSelect__texts--${e.size}`])
        }, [
          d("span", {
            class: f(["ChipSelect__label", [
              `ChipSelect__label--${e.size}`,
              { "ChipSelect__label--small": M.value }
            ]])
          }, V(e.label), 3),
          d("span", {
            class: f(["ChipSelect__selected-value", {
              "ChipSelect__selected-value--visible": c.value.length
            }])
          }, V(c.value), 3)
        ], 2),
        e.loading ? (r(), u("div", {
          key: 3,
          class: f(["ChipSelect__spinner", `ChipSelect__spinner--${e.size}`])
        }, [
          B(C(re), { size: _.value }, null, 8, ["size"])
        ], 2)) : (r(), u("div", {
          key: 2,
          class: f(["ChipSelect__chevron", `ChipSelect__chevron--${e.size}`])
        }, [
          v.value ? (r(), E(C(ae), {
            key: 0,
            size: _.value
          }, null, 8, ["size"])) : (r(), E(C(oe), {
            key: 1,
            size: _.value
          }, null, 8, ["size"]))
        ], 2))
      ], 42, ke),
      B(C(Se), {
        ref_key: "listboxRef",
        ref: i,
        modelValue: a.value,
        "onUpdate:modelValue": y[0] || (y[0] = (P) => a.value = P),
        class: "ChipSelect__listbox",
        variant: s.variant === "multiple" ? "checkbox" : "ticks",
        "multi-selectable": s.variant === "multiple",
        options: e.loading ? [] : e.options,
        "caption-message": g.value,
        show: v.value,
        onClearAll: q,
        onClickSelected: j
      }, ee({ _: 2 }, [
        e.options.length === 0 && !e.loading ? {
          name: "empty-content",
          fn: le(() => [
            d("div", we, V(e.emptyMessage), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue", "variant", "multi-selectable", "options", "caption-message", "show"])
    ], 544));
  }
});
export {
  de as _,
  Me as a
};
